import { v4 as uuidv4 } from 'uuid';

export let data = [];
export let addItem = {
  id: '',
  content: '',
  timbreId: null,
  virtualManId: null,
  speechParam: null,
  videoParam: null,
  logoParams: [],
};

export const setData = (newData) => {
  data = newData;
};

export const resetData = () => {
  data = [];
  addItem = {
    id: '',
    content: '',
    timbreId: null,
    virtualManId: null,
    speechParam: null,
    videoParam: null,
    logoParams: [],
  };
};
